module.exports = __webpack_public_path__ + "media/images/bitmap/smartphone-in-the-mall-63af6128deaf29ef00a5ffe61a02b704.png";